import { useContext } from 'react';
import { RoutingContext } from './RoutingContext';

const UseRoutingContext = () => {
  const context = useContext(RoutingContext);
  if (!context) {
    throw new Error('useRouting must be used within a RoutingProvider');
  }
  return context;
};

export default UseRoutingContext;
